import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  const isDisabled = loaderService.isDisabled$();

  // Manage the request counter within the interceptor
  loaderService.totalRequests++;

  if (!isDisabled) {
    loaderService.setLoading(true);
  }

  return next(req).pipe(
    finalize(() => {
      loaderService.totalRequests--;
      if (loaderService.totalRequests === 0 && !isDisabled) {
        loaderService.setLoading(false);
      }
    })
  );
};
